export const CONTENT_ANNOUNCEMENTS_TEMPLATE_ID = 'content-announcement';
